import { render, staticRenderFns } from "./Ctf.vue?vue&type=template&id=56b12132&"
import script from "./Ctf.vue?vue&type=script&lang=js&"
export * from "./Ctf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports